<div class="content">
  <div class="newGroupButton">
    <button mat-raised-button (click)="onClickNewConfiguration()">{{ "visibility.labels.newGroup" | translate}}</button>
  </div>
  <table mat-table [dataSource]="dataSourceVisibilityGroup" class="mat-elevation-z8">
    <div class="groupName">
      <ng-container matColumnDef="groupVisibility">
        <th mat-header-cell *matHeaderCellDef> {{ "visibility.labels.groupName" | translate}} </th>
        <td mat-cell *matCellDef="let row" class="groupName-cell"> {{ row.Name }} </td>
      </ng-container>
    </div>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="centered-header"> {{ "visibility.labels.actions" | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <div>
          <button mat-raised-button class="edit-button" (click)="editVisibilityGroup(row)">
            {{ "visibility.labels.edit" | translate}}
          </button>
          <button mat-raised-button (click)="deleteVisibilityGroup(row.Id)">
            {{ "visibility.labels.delete" | translate}}
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsGroupVisibility"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsGroupVisibility;"></tr>
  </table>
</div>